import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { tagKeys } from '@/shared/lib/query/queryKeys';

import { updateClassificationApi } from '@/features/tags/api';
import type { UpdateClassificationRequest } from '@/features/tags/api';

export const useUpdateClassification = (classificationName?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: UpdateClassificationRequest) => updateClassificationApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tagKeys.categories() });
      if (classificationName) {
        queryClient.invalidateQueries({ queryKey: tagKeys.categoryDetail(classificationName) });
      }

      notification.success({
        message: NOTIFICATION_MESSAGES.CLASSIFICATION_UPDATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.CLASSIFICATION_UPDATE_SUCCESS_DESC,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
